import { render, staticRenderFns } from "./MenungguRespon.vue?vue&type=template&id=2e27730a&scoped=true&"
import script from "./MenungguRespon.vue?vue&type=script&lang=js&"
export * from "./MenungguRespon.vue?vue&type=script&lang=js&"
import style0 from "./MenungguRespon.vue?vue&type=style&index=0&id=2e27730a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27730a",
  null
  
)

export default component.exports